import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image'

import { PosterUrl } from '../constants';

const Hero = () => {
    return (
        <Row id="hero">
            <Col className="text-center">
                <Image src={PosterUrl} fluid />
            </Col>
        </Row>
    );
}

export default Hero;